module.exports = __webpack_public_path__ + "521a9fe281dd2c848262edadff1b94e5.png";